import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { of, throwError } from 'rxjs';
import { MiscFunctionsService } from './misc-functions.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  readonly basePath: string = 'https://nevoaibutlerdebugapi-staging.azurewebsites.net';

  constructor(private http: HttpClient,
              private miscFunctionsService: MiscFunctionsService) { }

  public logDebug=(message: any) => {
    this.log(message, 'Debug');
  }

  public logError = (message: any) => {
    this.log(message, 'Error');
  }

  public logFatal =(message: any) =>{
    this.log(message, 'Fatal');
  }

  public logInfo =(message: any) => {
    this.log(message, 'Information');
  }

  public logWarning = (message: any) => {
    this.log(message, 'Warning');
  }

  private log =(message: any, level:any) => {
    console.log(`[${level}] ${message}`);

    const urlSegments = window.location.hostname.split('.');
    const timeStamp = formatDate(new Date().toLocaleString("en-US"), 'yyyy-MM-dd HH:mm:ss', 'en');
    const loggingFormat = `[${timeStamp}][DeviceAuthentication][${level}][${window.location.hostname}]${message}[LogEnd]`;
    const logCollectionInBase64 = this.miscFunctionsService.base64Encode(loggingFormat);

    // console.log({ logCollectionInBase64: logCollectionInBase64 });

    this.http.post(this.basePath + '/api/Debug/Post', {
      logCollection: logCollectionInBase64
    }).pipe(
      catchError((response: HttpErrorResponse) => {
        // console.log('log.HttpErrorResponse -> ', JSON.stringify(response));
        let message = response.message;

        if (response.status === 200) {
          return of();
        } else {
          if (response.error instanceof ErrorEvent) {
            // client-side error
            message = `Error: ${response.error.message}`;
          }
        }

        // return an observable with a user-facing error message
        return throwError(()=> message);
      })
    ).subscribe(() => {
      console.log('Successfully logged to SEQ');
    });
  }
}
